export default function convertPathToRegex(path: string) {
  const aPath = path.split('/');

  const source = `^(\/latest|\/V[0-9]\\.[0-9]{1,2}(\\.[0-9]{0,3})?)?${aPath
    .map((segment, index) => {
      const isLast = index === aPath.length - 1;
      if (isLast) {
        return segment.replace('?', '\\?').replace('*', '.*').replace('+', '[^\\/]+');
      } else {
        return segment.replace('?', '\\?').replace('*', '[^\\/]+').replace('+', '[^\\/]+');
      }
    })
    .join('\\/')}$`;

  return new RegExp(source);
}
